// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2emyH","title":"BackImages_title__UDRve","images":"BackImages_images__CaE_-"};